import styled from 'styled-components/macro';

const ItemInfo = styled.span`
  padding: 0 16px;
  margin-bottom: 8px;
  opacity: 0.6;
  color: #fff;
`;

export default ItemInfo;
